/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAutomationsRouteImport } from './routes/_app/automations'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppMeRouteImport } from './routes/_app/me'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit'
import { Route as AppAdminFeedbackRouteImport } from './routes/_app/admin/feedback'
import { Route as AppAdminMemoryRouteImport } from './routes/_app/admin/memory'
import { Route as AppAdminPeopleRouteImport } from './routes/_app/admin/people'
import { Route as AppAdminSettingsRouteImport } from './routes/_app/admin/settings'
import { Route as AppAdminTeamsRouteImport } from './routes/_app/admin/teams'
import { Route as AppCIdRouteImport } from './routes/_app/c.$id'
import { Route as AppChSlugRouteImport } from './routes/_app/ch.$slug'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAutomationsRoute = AppAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppMeRoute = AppMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFeedbackRoute = AppAdminFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminMemoryRoute = AppAdminMemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminPeopleRoute = AppAdminPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTeamsRoute = AppAdminTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppCIdRoute = AppCIdRouteImport.update({
  id: '/c/$id',
  path: '/c/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppChSlugRoute = AppChSlugRouteImport.update({
  id: '/ch/$slug',
  path: '/ch/$slug',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/signin': typeof SigninRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/automations': typeof AppAutomationsRoute
  '/inbox': typeof AppInboxRoute
  '/me': typeof AppMeRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/feedback': typeof AppAdminFeedbackRoute
  '/admin/memory': typeof AppAdminMemoryRoute
  '/admin/people': typeof AppAdminPeopleRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/teams': typeof AppAdminTeamsRoute
  '/c/$id': typeof AppCIdRoute
  '/ch/$slug': typeof AppChSlugRoute
}
export interface FileRoutesByTo {
  '/signin': typeof SigninRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/automations': typeof AppAutomationsRoute
  '/inbox': typeof AppInboxRoute
  '/me': typeof AppMeRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/': typeof AppIndexRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/feedback': typeof AppAdminFeedbackRoute
  '/admin/memory': typeof AppAdminMemoryRoute
  '/admin/people': typeof AppAdminPeopleRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/admin/teams': typeof AppAdminTeamsRoute
  '/c/$id': typeof AppCIdRoute
  '/ch/$slug': typeof AppChSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/signin': typeof SigninRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/automations': typeof AppAutomationsRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/me': typeof AppMeRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/feedback': typeof AppAdminFeedbackRoute
  '/_app/admin/memory': typeof AppAdminMemoryRoute
  '/_app/admin/people': typeof AppAdminPeopleRoute
  '/_app/admin/settings': typeof AppAdminSettingsRoute
  '/_app/admin/teams': typeof AppAdminTeamsRoute
  '/_app/c/$id': typeof AppCIdRoute
  '/_app/ch/$slug': typeof AppChSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signin'
    | '/admin'
    | '/automations'
    | '/inbox'
    | '/me'
    | '/auth/verify'
    | '/admin/audit'
    | '/admin/feedback'
    | '/admin/memory'
    | '/admin/people'
    | '/admin/settings'
    | '/admin/teams'
    | '/c/$id'
    | '/ch/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signin'
    | '/admin'
    | '/automations'
    | '/inbox'
    | '/me'
    | '/auth/verify'
    | '/'
    | '/admin/audit'
    | '/admin/feedback'
    | '/admin/memory'
    | '/admin/people'
    | '/admin/settings'
    | '/admin/teams'
    | '/c/$id'
    | '/ch/$slug'
  id:
    | '__root__'
    | '/_app'
    | '/signin'
    | '/_app/admin'
    | '/_app/automations'
    | '/_app/inbox'
    | '/_app/me'
    | '/auth/verify'
    | '/_app/'
    | '/_app/admin/audit'
    | '/_app/admin/feedback'
    | '/_app/admin/memory'
    | '/_app/admin/people'
    | '/_app/admin/settings'
    | '/_app/admin/teams'
    | '/_app/c/$id'
    | '/_app/ch/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  SigninRoute: typeof SigninRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/automations': {
      id: '/_app/automations'
      path: '/automations'
      fullPath: '/automations'
      preLoaderRoute: typeof AppAutomationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me': {
      id: '/_app/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AppMeRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/feedback': {
      id: '/_app/admin/feedback'
      path: '/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AppAdminFeedbackRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/memory': {
      id: '/_app/admin/memory'
      path: '/memory'
      fullPath: '/admin/memory'
      preLoaderRoute: typeof AppAdminMemoryRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/people': {
      id: '/_app/admin/people'
      path: '/people'
      fullPath: '/admin/people'
      preLoaderRoute: typeof AppAdminPeopleRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/settings': {
      id: '/_app/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AppAdminSettingsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/teams': {
      id: '/_app/admin/teams'
      path: '/teams'
      fullPath: '/admin/teams'
      preLoaderRoute: typeof AppAdminTeamsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/c/$id': {
      id: '/_app/c/$id'
      path: '/c/$id'
      fullPath: '/c/$id'
      preLoaderRoute: typeof AppCIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ch/$slug': {
      id: '/_app/ch/$slug'
      path: '/ch/$slug'
      fullPath: '/ch/$slug'
      preLoaderRoute: typeof AppChSlugRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminFeedbackRoute: typeof AppAdminFeedbackRoute
  AppAdminMemoryRoute: typeof AppAdminMemoryRoute
  AppAdminPeopleRoute: typeof AppAdminPeopleRoute
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute
  AppAdminTeamsRoute: typeof AppAdminTeamsRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminFeedbackRoute: AppAdminFeedbackRoute,
  AppAdminMemoryRoute: AppAdminMemoryRoute,
  AppAdminPeopleRoute: AppAdminPeopleRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminTeamsRoute: AppAdminTeamsRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppAutomationsRoute: typeof AppAutomationsRoute
  AppInboxRoute: typeof AppInboxRoute
  AppMeRoute: typeof AppMeRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCIdRoute: typeof AppCIdRoute
  AppChSlugRoute: typeof AppChSlugRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppAutomationsRoute: AppAutomationsRoute,
  AppInboxRoute: AppInboxRoute,
  AppMeRoute: AppMeRoute,
  AppIndexRoute: AppIndexRoute,
  AppCIdRoute: AppCIdRoute,
  AppChSlugRoute: AppChSlugRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  SigninRoute: SigninRoute,
  AuthVerifyRoute: AuthVerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
